/**
 * Filter operators utility for table advanced filtering
 * Provides filter operators based on data types detected by getColumnDataType
 */

/**
 * Text-specific filter operators
 */
const textOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
  { label: "Contains", value: "contains" },
  { label: "Not Contains", value: "notContains" },
  { label: "Starts With", value: "startsWith" },
  { label: "Ends With", value: "endsWith" },
];

/**
 * Numeric filter operators
 */
const numericOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
  { label: "Greater Than", value: "greaterThan" },
  { label: "Less Than", value: "lessThan" },
  { label: "Greater Than or Equal", value: "greaterThanOrEqual" },
  { label: "Less Than or Equal", value: "lessThanOrEqual" },
];

/**
 * Date filter operators
 */
const dateOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
  { label: "After", value: "greaterThan" },
  { label: "Before", value: "lessThan" },
  { label: "On or After", value: "greaterThanOrEqual" },
  { label: "On or Before", value: "lessThanOrEqual" },
];

/**
 * Boolean filter operators
 */
const booleanOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
];

/**
 * Array filter operators
 */

const arrayOperators = [
  { label: "Equal-array", value: "equal" },
  { label: "Not Equal-array", value: "notEqual" },
  { label: "Contains-array", value: "contains" },
  { label: "Not Contains-array", value: "notContains" },
];

/**
 * Enum filter operators for dropdown/select fields
 */
const enumOperators = [
  { label: "Equal-enum", value: "equal" },
  { label: "Not Equal-enum", value: "notEqual" },
];

/**
 * Email and URL filter operators
 */
const webOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
  { label: "Contains", value: "contains" },
  { label: "Not Contains", value: "notContains" },
];

/**
 * Default operators for unknown types
 */
const fallbackOperators = [
  { label: "Equal", value: "equal" },
  { label: "Not Equal", value: "notEqual" },
  { label: "Greater Than", value: "greaterThan" },
  { label: "Less Than", value: "lessThan" },
  { label: "Contains", value: "contains" },
  { label: "Not Contains", value: "notContains" },
];

/**
 * Returns appropriate filter operators based on the data type
 * @param {String} dataType - The data type detected by getColumnDataType
 * @returns {Array} Array of filter operator options
 */
export const getFilterOperatorsByDataType = (dataType) => {
  switch (dataType) {
    case "string":
    case "object":
    case "phone":
      return textOperators;

    case "number":
    case "integer":
    case "currency":
    case "percentage":
      return numericOperators;

    case "date":
      return dateOperators;

    case "boolean":
      return booleanOperators;

    case "array":
      return arrayOperators;

    case "enum":
      return enumOperators;

    case "email":
    case "url":
      return webOperators;

    default:
      return fallbackOperators;
  }
};

export default getFilterOperatorsByDataType;
